export default __webpack_public_path__ + "static/media/var2.50777f01.png";